import React from 'react';
import styled from 'styled-components';

// Stilizziamo una Colonna per mantenere il padding
// l'elemento sarà renderizzato in un compoente Row (come gli altri widget)
const ConfigContainerSized = styled.div`
  max-width: ${props => props.theme.contentMaxWidth}px;
  margin: 0 auto;
  /* border: 12px solid ${props => props.theme.Layout?.colorBgBody}; */
  background-color: #fff;

  border-radius: 12px;
  padding: 24px;
  box-shadow: ${props => props.theme.boxShadowSecondary};
`;
const ConfigContainerWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 12px;
  background-color: ${props => props.theme.Layout?.colorBgBody};
`;

export interface ISubsectionConfigContainerProps {
  children?: React.ReactNode;
}
/**
 * Parte superiore del Widget  "Quesito" Con il Titolo e la descrizione
 */
export function SubsectionConfigContainer(
  props: ISubsectionConfigContainerProps,
) {
  const { children } = props;
  return (
    <ConfigContainerWrapper>
      <ConfigContainerSized>{children}</ConfigContainerSized>
    </ConfigContainerWrapper>
  );
}
